import __request__ from "routing/request";
export function getAllCategories(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.illuminate/stream_categories", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function updateStreamCategories(streamId, requestOptions) {
  return __request__("PUT", `/plugins/org.graylog.plugins.illuminate/stream_categories/${streamId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
